import { BRAND_SPLIT_FIELDS_UPDATE } from "constants/action-types";

export const updateSplitFields = (fields: string[]) => ({
    payload: fields,
    type: BRAND_SPLIT_FIELDS_UPDATE,
});
